import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { VisitorRoleTask } from '../../visit-roles.model';

@Component({
  selector: 'app-visit-role-task-dialog',
  templateUrl: './visit-role-task-dialog.component.html',
  styleUrls: ['./visit-role-task-dialog.component.scss']
})
export class VisitRoleTaskDialogComponent implements OnInit {


  task: VisitorRoleTask;

  formGroup = new FormGroup({
    name: new FormControl(null, []),
    validity: new FormControl(0, []),
    optional: new FormControl(false, []),
  });

  constructor(
    public dialogRef: MatDialogRef<VisitRoleTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.task = data as VisitorRoleTask
  }

  ngOnInit(): void {

    this.formGroup.patchValue({
      name: this.task.name,
      validity: this.task.validity,
      optional: this.task.optional
    });

    this.formGroup.valueChanges.subscribe((value) => {

      console.log('handling task field details', value);

      this.task.name = value.name;
      this.task.validity = value.validity;
      this.task.optional = value.optional;
    });

  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

  public confirm(): void {
    this.dialogRef.close(this.task);
  }

}
